<template>
  <div class="goods_box">
    <div class="left">
      <div class="box">
        <img class="goods_icon" :src="detail.icon" alt="">
      </div>
    </div>
    <div class="right">
      <div class="main_cont">
        <div class="name_num">
          <div class="name">
            <p>{{( ItemName.length <= 5) ? ItemName: ItemName.slice(0,5) }}</p>
            <p class="line2">
              {{( ItemName.length > 5) ? ItemName.slice(5,ItemName.length): '' }}
            </p>
          </div>
          <div class="num" v-if="type == 1">剩余数量：{{  detail.ItemDes&&detail.ItemDes.dwCount?detail.ItemDes.dwCount:'' }}</div>
          <div class="num" v-else-if="type == 2">数量：{{detail.num}}</div>
        </div>
        <div class="price" v-if="min&&max">
          参考价格：<span class="yen">{{ min }}~{{ max }}</span>
        </div>
        <div class="price" v-else>
          售价：<span class="yen">&yen;{{ detail.price }}</span>
        </div>
        <div class="btStrengCount" v-if="detail.ItemDes&&detail.ItemDes.btStrengCount > 0">
            +{{ detail.ItemDes.btStrengCount }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sell-component',
  props: {
    detail: {
      type: Object,
      default: {}
    },
    ItemName: {
      type: String,
      default: ''
    },
    type: {
      type: [String,Number],
      default: 1
    },
    min: {
      type: [String,Number]
    },
    max: {
      type: [String,Number]
    }
  },
  data() {
    return {
      
    }
  },
}
</script>
<style lang="less" scoped>
.goods_box {
  display: flex;
  align-items: flex-start;
  height: 8.6rem;
  background-color: #fff;
  border-radius: 0.3rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  overflow: hidden;

  .left {
    width: 17rem;
    height: 100%;
    background: url(../assets/bx/goods_bg.png) no-repeat 0 0 / 100% 100%;
    position: relative;

    .box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 3rem;
      height: 3rem;
      background: url(../assets/bx/goods_kuang.png) no-repeat 0 0 / 100% 100%;

      .goods_icon {
        height: 100%;
      }
    }
  }

  .right {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      margin-bottom: 1rem;

      &:nth-last-child(1) {
        margin-bottom: 0;
      }

      &.price {
        font-size: 1.6rem;

        .yen {
          color: var(--red);
          font-weight: 700;

          .symbol {
            display: inline-block;
            transform: scale(0.75);
            transform-origin: 0 100%;
          }
        }
      }

      &.num {
        color: #aaa;

        .suffix {
          color: var(--enough);
        }
      }
    }

    .main_cont {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: .6rem 1rem 1rem;
      position: relative;
      .btStrengCount {
        position: absolute;
        top: 3rem;
        right: 1rem;
        font-size: 1.6rem;
        font-weight: 700;
        color: #00bb00c5;
      }
      .name_num {
        position: relative;

        .name {
          word-break: break-all;
          font-size: 1.45rem;

          p {
            line-height: 1.6rem;
          }

          .line2 {
            width: 15rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .num {
          position: absolute;
          right: 0;
          top: 0;
          color: #aaa;
          font-size: 1.2rem;
          transform: scale(0.95);
          transform-origin: 100% 100%;
          margin-left: 0.8rem;
          white-space: nowrap;

        }
      }

      .price {
        color: #aaa;

        .yen {
          color: var(--red);
          font-weight: 700;
          margin-right: 0.8rem;
          position: relative;

          // &::after {
          //   content: '/';
          //   position: absolute;
          //   right: -.6rem;
          //   top: -.1rem;
          //   font-size: 1.5rem;
          //   transform: rotate(10deg);
          //   font-weight: normal;
          // }
        }

        .percent {
          color: #000;
        }
      }
    }
  }
}</style>